// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD9JKwSFmPnDI7QRieiglyD8ACzY1ZdSiQ",
    authDomain: "ionictestapp-882cc.firebaseapp.com",
    databaseURL: "https://ionictestapp-882cc.firebaseio.com",
    projectId: "ionictestapp-882cc",
    storageBucket: "ionictestapp-882cc.appspot.com",
    messagingSenderId: "173916993149",
    appId: "1:173916993149:web:733541f80863bcf5a42314",
    measurementId: "G-KZPYJEJG7W"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
